<nb-select fullWidth
           [placeholder]="placeholder"
           [(selected)]="value"
           [disabled]="isDisabled">
  @for (v of values; track v) {
    <nb-option [value]="v">{{ v | sensorPurpose }}</nb-option>
  }
</nb-select>
